<div class="flex-1 flex flex-col w-full min-h-0">
  @if (hasMessages()) {
    <!-- The bar above the page carries the logo, so the row holds the action alone, on the right. -->
    <div
      class="min-h-10 w-full py-4 px-6 not-expanded:py-2 not-expanded:px-4 flex gap-2 items-center justify-end shrink-0">
      <button
        mibButton
        type="button"
        shape="round"
        [size]="clearButtonSize()"
        theme="ai"
        class="[--color-mib-btn-ai-border-pressed:var(--color-mib-btn-ai-bg-pressed)] [--color-mib-btn-ai-text-pressed:var(--color-mib-btn-ai-text)]"
        aria-label="Clear chat history"
        mibTooltip="Clear chat history"
        mibTooltipShowDelay="500"
        (click)="clearChatHistory()">
        <svg mib-icon name="trash"></svg>
      </button>
    </div>
  }

  <mai-chat
    class="flex flex-1 min-h-0 w-full justify-center"
    [chatInfo]="chatInfo()"
    [chatReady]="true"
    (timeLinkClick)="manageTimeLinkClick($event)"></mai-chat>
</div>
<mai-copyright-and-legal-link
  class="py-4 pb-2 not-expanded:px-4 not-expanded:pb-4 text-mib-branding-400"></mai-copyright-and-legal-link>
